<div id="overlay">
  @if (startLoader) {
<ap-loading id="text" class="loader-class" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
}
</div>
<dst-create-disclosure-actions [isView]="true" [disableAll]="disableActions" [disabled]="!loaded" (onSaveClick)="save()"
  (onCancelClick)="cancel()" [disableS3Upload]="false" (onS3UploadClick)="s3Upload()" 
  [isFiled]="stmtData?.isfiled" [isQAR]="stmtData?.isqar" [statementId]="stmtData?.statementid"></dst-create-disclosure-actions>
<div class="form-template-wrapper" id="temp368form188">
  <div>
    <div align=center>
      <b>
      @if (loaded) {
<span class="template-color-blue">
        {{stmtData.dcnname}}
      </span>
}
      </b>
    </div>
    <div align="center">
      <B>
      @if (loaded) {
<span class="template-color-blue">
        {{stmtData.taxyear}} CONSOLIDATED FEDERAL INCOME TAX RETURN<br/>
        STATEMENT PURSUANT TO SECTION 1.368-3 <b>{{attMap['statementOption'] == undefined ? '' : attMap['statementOption'][0]}}</b>&nbsp;
        <br/>
        BY A CORPORATION A PARTY TO A REORGANIZATION AND BY A SIGNIFICANT SHAREHOLDER
      </span>
}
      </B>
    </div>
    <br/>
    Pursuant to Section 1.368-3 of the Regulations, the following information is furnished:
    <!-- The names and employer identification numbers (if any) of all such parties: -->
    <div [formGroup]="form188">
      <!-- <dst-template-header [parentFormGroup]="form184" (formOptionChanged)="onFormOptionChanged($event)"></dst-template-header>-->
      <ol style="margin: 15px;">
        <li>
          The following:<br>
          <b>Target Corporation </b>
          @if (loaded) {
<span class="template-color-blue">{{primaryEntityName}}</span>
}, EIN:
          @if (loaded) {
<span class="template-color-blue">{{stmtData.primaryein == null ? 'N/A' : stmtData.primaryein}}</span>
}, a
          @if (loaded) {
<span class="template-color-blue">
            @if (prEntityNull) {
<span>Target </span>
}
              {{stmtData.primarycountryincdesc == null ? '' : stmtData.primarycountryincdesc}}
          </span>
}@if (loaded) {
<span class="template-color-blue">{{primaryCorpTypeTxt}}</span>
},<br>
          <b>Acquirer </b>
          @if (loaded) {
<span class="template-color-blue">{{secondaryEntityName}}</span>
}, EIN:
          @if (loaded) {
<span class="template-color-blue">{{stmtData.secondaryein == null ? 'N/A' : stmtData.secondaryein}}</span>
}, a
          @if (loaded) {
<span class="template-color-blue">
            @if (secEntityNull) {
<span>Acquirer </span>
}
              {{stmtData.secondarycountryincdesc == null ? '' : stmtData.secondarycountryincdesc}}
          </span>
}@if (loaded) {
<span class="template-color-blue">{{secondaryCorpTypeTxt}}</span>
}, <br>
          @if (shdspLeid) {
<div>
            <b>Significant Holder </b>
            <span class="template-color-blue">{{!lookupdata[0] ? '' : lookupdata[0].ENTITY}}</span> EIN: <span
            class="template-color-blue">{{!lookupdata[0] ? '' : lookupdata[0].EIN}}</span>, a
            <span class="template-color-blue">{{!lookupdata[0] ? '' : lookupdata[0].COUNTRYNAME}}</span>@if (loaded) {
<span class="template-color-blue">{{shCorpTypeTxt}}</span>
},
            <br>
          </div>
}
          @if (loaded && attMap?.['Para1']?.[0]) {
<span class="template-color-blue">
            {{attMap['Para1'][0]}}<br/>
          </span>
}
          are parties in a transaction that qualified as a reorganization
          under Code Section <span>{{pickListVal}}</span>
        </li>
        <li>
          The date of the reorganization was<br/>
          @if (loaded) {
<span>
          {{attMap['LiquidationDate'] == undefined ? '' : attMap['LiquidationDate'][0]}}
        </span>
}
        </li>
        <li>
          <!--<u>Disclosure required for Target/Corporation:</u>-->
          The value and basis of the assets, stock or securities of the target corporation transferred in the
          transaction, determined immediately before the transfer and aggregated as follows:
          <ol class="inner-list">
            <li>
              <div class="list-content">
                Importation property transferred in a loss importation transaction, as defined in Section 1.362-3(c)(2) and (3), respectively:<br/>
                @if (loaded) {
<span class="template-color-blue">
                  {{attMap['importationPropertyDesc'] == undefined ? '' : (attMap['importationPropertyDesc'][0] ? attMap['importationPropertyDesc'][0] : 'None.')}}
                </span>
}
              </div>
            </li>
            <li>
              <div class="list-content">
                Loss duplication property as defined in Section 1.362-4(g)(1):<br/>
                @if (loaded) {
<span class="template-color-blue">
                  {{attMap['lossDuplicationPropertyDesc'] == undefined ? '' : (attMap['lossDuplicationPropertyDesc'][0] ? attMap['lossDuplicationPropertyDesc'][0] : 'None.')}}
                </span>
}
              </div>
            </li>
            <li>
              <div class="list-content">
                Property with respect to which any gain or loss was recognized on the transfer (without regard to whether such property is also identified in
                paragraph (a)(3)(i) or (ii) of this section)<br/>
                @if (loaded) {
<span class="template-color-blue">
                  {{attMap['gainLossPropertyDesc'] == undefined ? '' : (attMap['gainLossPropertyDesc'][0] ? attMap['gainLossPropertyDesc'][0] : 'None.')}}
                </span>
}
              </div>
            </li>
            <li>
              <div class="list-content">
                Property not described in paragraph (a)(3)(i), (ii), or (iii) of this section;
                <table class="table-view-layout">
                  @if (loaded) {
<tbody>
                  <tr>
                    <td colspan="3"></td>
                    <td><span>{{selBasisTxt}} Basis to the Transferor Corporation</span></td>
                    <td><span>Fair Market Value on Date of Transfer</span></td>
                  </tr>
                  <tr>
                    <td colspan="2"></td>
                    <td class="header-column con-left"><span><b>Description</b></span></td>
                    <td>
                      <span><b><u>{{getSelCurrency(0)}}</u></b></span>
                    </td>
                    <td>
                      <span><b><u>{{getSelCurrency(1)}}</u></b></span>
                    </td>
                  </tr>
                  @if (attMap?.['Desc']?.length >= 1) {

                    @for (val of attMap['Desc']; track $index; let i = $index) {
<tr>
                      <td colspan="2" style="width: 6%;"></td>
                      <td class="con-left" style="width: 50%;"><span>{{val}} </span></td>
                      <td style="text-align: right; width: 22%;">
                        <span>{{attMap['BasisAmt'] == undefined ? '' : attMap['BasisAmt'][i] | number}}</span>
                      </td>
                      <td style="text-align: right; width: 22%;">
                        <span>{{attMap['FMVAmt'] == undefined ? '' : attMap['FMVAmt'][i] | number}}</span>
                      </td>
                    </tr>
}
                    @if (descTotalAvl) {
<tr>
                      <td colspan="2"></td>
                      <td></td>
                      <td align="center">
                        <hr style="width: 100%; border-top: 1px solid rgba(0,0,0,.5);"/>
                      </td>
                      <td align="center">
                        <hr style="width: 100%; border-top: 1px solid rgba(0,0,0,.5);"/>
                      </td>
                    </tr>
}
                    @if (descTotalAvl) {
<tr>
                      <td colspan="2"></td>
                      <td class="con-left"><span>Total</span></td>
                      <td style="text-align: right">
                        <span>{{totalAmt('BasisAmt') | number}}</span>
                      </td>
                      <td style="text-align: right">
                        <span>{{totalAmt('FMVAmt') | number}}</span>
                      </td>
                    </tr>
}
                  
}
  
                  </tbody>
}
                </table>
              </div>
            </li>
          </ol>
          @if (shdspLeid) {

            <p><u>Disclosure required for Significant Holder</u> (if applicable):</p>
            <p>The value and basis of all the stock or securities of the target corporation held by the significant holder that is transferred in the
              transaction and such holder's basis in that stock or securities, determined immediately before the transfer and aggregated as follows:</p>
            <ol class="inner-list">
              <li>
                Stocks and securities with respect to which an election is made under Section 362(e)(2)(C):
                @if (loaded) {
<span class="template-color-blue">
              {{attMap['stocksSecurityPropertyDesc'] == undefined ? '' : attMap['stocksSecurityPropertyDesc'][0]}}
            </span>
}
              </li>
              <li>
                Stocks and securities not described in Section 1.368-3(b)(3)(i):
                <table class="table-view-layout">
                  @if (loaded) {
<tbody>
                  <tr>
                    <td colspan="3"></td>
                    <td><span>{{selBasisTxtOthr}} Basis to the Significant Holder</span></td>
                    <td><span>Fair Market Value on Date of Transfer</span></td>
                  </tr>
                  <tr>
                    <td colspan="2"></td>
                    <td class="header-column con-left"><span><b>Description</b></span></td>
                    <td>
                      <span><b>{{getSelCurrency(2)}}</b></span>
                    </td>
                    <td>
                      <span><b>{{getSelCurrency(3)}}</b></span>
                    </td>
                  </tr>
                  @if (attMap?.['Desc1']?.length >= 1) {


                    @for (val of attMap['Desc1']; track $index; let i = $index) {
<tr>
                      <td colspan="2" style="width: 6%;"></td>
                      <td class="con-left" style="width: 50%;"><span>{{val}} </span></td>
                      <td style="text-align: right; width: 22%;">
                        <span>{{attMap['BasisAmt1'] == undefined ? '' : attMap['BasisAmt1'][i] | number}}</span>
                      </td>
                      <td style="text-align: right; width: 22%;">
                        <span>{{attMap['FMVAmt1'] == undefined ? '' : attMap['FMVAmt1'][i] | number}}</span>
                      </td>
                    </tr>
}
                    @if (descTotalAvl) {
<tr>
                      <td colspan="2"></td>
                      <td></td>
                      <td align="center">
                        <hr style="width: 100%; border-top: 1px solid rgba(0,0,0,.5);"/>
                      </td>
                      <td align="center">
                        <hr style="width: 100%; border-top: 1px solid rgba(0,0,0,.5);"/>
                      </td>
                    </tr>
}
                    @if (descTotalAvl) {
<tr>
                      <td colspan="2"></td>
                      <td class="con-left"><span>Total</span></td>
                      <td style="text-align: right">
                        <span>{{totalAmt('BasisAmt1') | number}}</span>
                      </td>
                      <td style="text-align: right">
                        <span>{{totalAmt('FMVAmt1') | number}}</span>
                      </td>
                    </tr>
}
                  
}
                  </tbody>
}
                </table>
              </li>
            </ol>
          
}
        </li>
        <li>
          The date and control number of any private letter ruling(s) issued by the Internal Revenue Service in connection with this reorganization:
          @if (loaded) {
<span>
          {{attMap['LiquidationDate'] == undefined ? '' : attMap['LiquidationDate'][1]}}  {{attMap['PLR'] == undefined ? 'NONE' : attMap['PLR'][0]}}
        </span>
}
        </li>
      </ol>
      <div>
        <div>Supplemental Information:</div>
        @if (loaded) {
<div>
          <div class="a-textarea-box a-field-length-validation form-inlines">
            @if (loaded) {
<textarea rows="5" cols="60" readonly class="txtborder w-100">
              {{attMap['section4text'] == undefined ? '' : attMap['section4text'][0]}}
            </textarea>
}
          </div>
        </div>
}
      </div>
      <table style="width:100%">
        @if (loaded) {
<tbody>
        <tr>
          <td class="footer-left">
            LEIDs: @if (prEntityNull) {
<span>Target </span>
} <span
            class="template-color-blue">{{stmtData.primaryleid == null ? '' : stmtData.primaryleid}}</span> / @if (secEntityNull) {
<span>Acquirer </span>
} <span
            class="template-color-blue">{{stmtData.secondaryleid == null ? '' : stmtData.secondaryleid}}</span> / <span
            class="template-color-blue">{{!lookupdata[0] ? '' : lookupdata[0].LEID}}</span>
          </td>
          <td class="footer-right">

          </td>
        </tr>
        <tr>
          <td class="footer-left">
            Statement ID: <span class="template-color-blue"> {{stmtData.statementid}}</span>
          </td>
        </tr>
        </tbody>
}
      </table>
    </div>
  </div>
</div>
